module.exports = __webpack_public_path__ + "static/img/2.7.a37f81d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/upload/picture/2.7.jpg
// module id = WiOl
// module chunks = 7